{
  "device_monitor": {
    "forms": {
      "device_name": "Name",
      "description": "Description",
      "reporting_interval": "Reporting Interval",
      "owner": "Owner",
      "shared_to": "Shared To",
      "model": "Model",
      "serial_number": "Serial",
      "power": "Power",
      "sensors": "Sensors",
      "device_details": "Details",
      "hardware": "Hardware",
      "temperature": "Temperature",
      "pressure": "Pressure",
      "connectivity": "Connectivity",
      "cellular_provider": "Cellular Provider",
      "signal_strength": "Signal Strength",
      "account": "Account",
      "ownership": "Ownership",
      "address": "Address",
      "com_type": "Com Type",
      "com_port": "Com Port",
      "location": "Location",
      "display": "Public Dashboard",
      "open_dashboard": "Open Dashboard",
      "settings": "Settings",
      "admin": "Admin"
    },
    "dialogs": {
      "sensor_delete": {
        "title": "Are you sure?",
        "content": "Are you sure you want to delete this sensor? You can't undo this action"
      }
    },
    "chart": {
      "data_gaps": "Data gaps",
      "limits": "Limits",
      "no_data": "No data to display",
      "no_data_select_params": "No data to display. Please select parameters."
    },
    "channel": "Channel %{id}",
    "toggle_parameters": "Toggle Parameters",
    "reload_data": "Reload data"
  }
}